import { UnitCardProps } from '@/components/UnitCard'
import { PlanCardProps } from '@/components/PlanCard'

const FPO_IMAGE = '/wp-content/plugins/ecs-spaces/public/images/spaces-fpo.png'

export const MOCK_UNITS: UnitCardProps[] = [
	{
		unitNumber: '1201-A',
		floorPlanName: 'The Alpine',
		imageUrl: FPO_IMAGE,
		beds: '2 Bed',
		baths: '2 Bath',
		sqft: 1145,
		availableDate: 'October 16, 2027',
		priceRange: '$2,150–$2,350',
		baseRent: '$2,050',
		leaseTerm: '12 Mo.',
		specialMessage: '1 month rent free on first full month of lease.',
		tags: [{ label: 'Renovated', color: 'brand' }],
		hasVirtualTour: true
	},
	{
		unitNumber: '0803-B',
		floorPlanName: 'The Birch',
		imageUrl: FPO_IMAGE,
		beds: '1 Bed',
		baths: '1 Bath',
		sqft: 756,
		availableDate: 'November 01, 2027',
		priceRange: '$1,650–$1,800',
		baseRent: '$1,550',
		leaseTerm: '12 Mo.',
		tags: [{ label: 'Smart Thermostat', color: 'brand' }],
		hasVirtualTour: false
	},
	{
		unitNumber: '1504-C',
		floorPlanName: 'The Cedar',
		imageUrl: FPO_IMAGE,
		beds: '3 Bed',
		baths: '2 Bath',
		sqft: 1380,
		availableDate: 'September 28, 2027',
		priceRange: '$2,800–$3,100',
		baseRent: '$2,700',
		leaseTerm: '14 Mo.',
		tags: [
			{ label: 'Mountain-Views', color: 'brand' },
			{ label: 'Corner Unit', color: 'brand' }
		],
		hasVirtualTour: true
	},
	{
		unitNumber: '0402-A',
		floorPlanName: 'The Alpine',
		imageUrl: FPO_IMAGE,
		beds: '2 Bed',
		baths: '2 Bath',
		sqft: 1145,
		priceRange: '$2,050–$2,250',
		baseRent: '$1,950',
		leaseTerm: '12 Mo.',
		tags: [],
		hasVirtualTour: false
	},
	{
		unitNumber: '0911-D',
		floorPlanName: 'The Dogwood',
		imageUrl: FPO_IMAGE,
		beds: 'Studio',
		baths: '1 Bath',
		sqft: 548,
		availableDate: 'October 01, 2027',
		priceRange: '$1,350–$1,450',
		baseRent: '$1,275',
		leaseTerm: '12 Mo.',
		specialMessage: '1 month rent free on first full month of lease.',
		tags: [],
		hasVirtualTour: false
	},
	{
		unitNumber: '1102-B',
		floorPlanName: 'The Birch',
		imageUrl: FPO_IMAGE,
		beds: '1 Bed',
		baths: '1 Bath',
		sqft: 756,
		availableDate: 'December 15, 2027',
		priceRange: '$1,700–$1,850',
		baseRent: '$1,600',
		leaseTerm: '13 Mo.',
		tags: [{ label: 'Renovated', color: 'brand' }],
		hasVirtualTour: true
	},
	{
		unitNumber: '0305-E',
		floorPlanName: 'The Elm',
		imageUrl: FPO_IMAGE,
		beds: '1 Bed',
		baths: '1 Bath',
		sqft: 680,
		availableDate: 'November 15, 2027',
		pricing: 'hidden',
		tags: [{ label: 'Renovated', color: 'brand' }],
		hasVirtualTour: false,
	},
	{
		unitNumber: '0602-C',
		floorPlanName: 'The Cedar',
		imageUrl: FPO_IMAGE,
		beds: '3 Bed',
		baths: '2 Bath',
		sqft: 1380,
		availableDate: 'January 10, 2028',
		priceRange: '$2,900–$3,200',
		baseRent: '$2,800',
		leaseTerm: '12 Mo.',
		tags: [],
		hasVirtualTour: false,
	},
	{
		unitNumber: '0710-A',
		floorPlanName: 'The Alpine',
		imageUrl: FPO_IMAGE,
		beds: '2 Bed',
		baths: '2 Bath',
		sqft: 1145,
		availableDate: 'February 01, 2028',
		priceRange: '$2,100–$2,300',
		baseRent: '$2,000',
		leaseTerm: '12 Mo.',
		tags: [{ label: 'Smart Thermostat', color: 'brand' }],
		hasVirtualTour: true,
	}
]

export const MOCK_PLANS: PlanCardProps[] = [
	{
		planName: 'The Alpine',
		imageUrl: FPO_IMAGE,
		beds: '2 Bed',
		baths: '2 Bath',
		sqftRange: '1,100–1,145',
		matchingUnits: 8,
		totalPrice: '$2,050–$2,350',
		baseRent: '$1,950',
		leaseTerm: '12 Mo.',
		hasDisclaimerSymbol: true,
		tags: [{ label: 'Renovated', color: 'brand' }],
		hasVirtualTour: true
	},
	{
		planName: 'The Birch',
		imageUrl: FPO_IMAGE,
		beds: '1 Bed',
		baths: '1 Bath',
		sqftRange: '720–756',
		matchingUnits: 12,
		totalPrice: '$1,600–$1,850',
		baseRent: '$1,550',
		leaseTerm: '12 Mo.',
		tags: [],
		hasVirtualTour: false
	},
	{
		planName: 'The Cedar',
		imageUrl: FPO_IMAGE,
		beds: '3 Bed',
		baths: '2 Bath',
		sqftRange: '1,320–1,380',
		matchingUnits: 4,
		totalPrice: '$2,750–$3,100',
		baseRent: '$2,700',
		leaseTerm: '14 Mo.',
		hasFees: false,
		hasDisclaimerSymbol: true,
		tags: [
			{ label: 'Mountain-Views', color: 'brand' },
			{ label: 'Corner Unit', color: 'brand' }
		],
		hasVirtualTour: true
	},
	{
		planName: 'The Dogwood',
		imageUrl: FPO_IMAGE,
		beds: 'Studio',
		baths: '1 Bath',
		sqftRange: '510–548',
		matchingUnits: 6,
		totalPrice: '$1,300–$1,450',
		baseRent: '$1,275',
		leaseTerm: '12 Mo.',
		specialMessage: '1 month rent free on first full month of lease.',
		tags: [],
		hasVirtualTour: false
	},
	{
		planName: 'The Elm',
		imageUrl: FPO_IMAGE,
		beds: '2 Bed',
		baths: '1 Bath',
		sqftRange: '950–980',
		matchingUnits: 3,
		totalPrice: '$1,850–$2,050',
		baseRent: '$1,800',
		leaseTerm: '12 Mo.',
		tags: [],
		hasVirtualTour: false
	},
	{
		planName: 'The Fern',
		imageUrl: FPO_IMAGE,
		beds: '1 Bed',
		baths: '1 Bath',
		sqftRange: '650–680',
		matchingUnits: 10,
		totalPrice: '$1,450–$1,600',
		baseRent: '$1,400',
		leaseTerm: '13 Mo.',
		tags: [{ label: 'Smart Thermostat', color: 'brand' }],
		hasVirtualTour: true
	},
	{
		planName: 'The Grove',
		imageUrl: FPO_IMAGE,
		beds: '2 Bed',
		baths: '2 Bath',
		sqftRange: '1,050–1,120',
		matchingUnits: 0,
		variant: 'unavailable',
		tags: [{ label: 'Waitlist', color: 'warning' }],
		hasVirtualTour: false
	},
	{
		planName: 'The Hawthorn',
		imageUrl: FPO_IMAGE,
		beds: '1 Bed',
		baths: '1 Bath',
		sqftRange: '780–810',
		matchingUnits: 5,
		variant: 'no-pricing',
		tags: [{ label: 'New', color: 'brand' }],
		hasVirtualTour: true
	}
]

export const MOCK_DETAIL_PLAN = {
	planName: 'The Alpine',
	beds: '2 Bed',
	baths: '2 Bath',
	sqftRange: '1,100–1,145',
	urgencyMessage: 'Only two homes left!',
	specialMessage: '1 month rent free on first full month of lease.',

	overview:
		'This updated two-bedroom, two-bath apartment home offers an open-concept living and dining room layout with optional fireplace, a modern kitchen with pantry, and spacious bedroom closets. A large wrap-around patio highlights this home.',
	features: [
		'Corner Apartment Home',
		'In-Home Washer and Dryer',
		'Stainless Steel Appliances',
		'Quartz-Style Countertops',
		'Undermount Sink',
		'Wood-Style Flooring in Living Areas',
		'Wrap-around Balcony',
		'Additional Storage on Balcony',
		'Spacious Closet',
		'Gas Fireplace',
		'Ceiling Fan',
		'Smart Thermostat',
		'Smart Home Lock',
		'Extra Large Soaking Tub',
		'USB Compatible Outlets'
	],
	tags: ['Renovated', 'Mountain-Views'],
	matchingUnits: [
		{
			unitNumber: '1201-A',
			floor: 12,
			availableDate: 'Sep 18',
			priceRange: '$2,150–$2,350',
			baseRent: '$2,050',
			leaseTerm: '12 Mo.'
		},
		{
			unitNumber: '1202-A',
			floor: 12,
			availableDate: 'Sep 18',
			priceRange: '$2,100–$2,300',
			baseRent: '$2,000',
			leaseTerm: '12 Mo.',
			hasSpecial: true
		},
		{
			unitNumber: '0402-A',
			floor: 4,
			availableDate: 'Oct 1',
			priceRange: '$2,050–$2,250',
			baseRent: '$1,950',
			leaseTerm: '12 Mo.'
		},
		{
			unitNumber: '0803-A',
			floor: 8,
			availableDate: 'Oct 15',
			priceRange: '$2,200–$2,400',
			baseRent: '$2,100',
			leaseTerm: '12 Mo.'
		},
		{
			unitNumber: '0604-A',
			floor: 6,
			availableDate: 'Nov 1',
			priceRange: '$2,080–$2,280',
			baseRent: '$1,980',
			leaseTerm: '12 Mo.'
		}
	]
}

export const MOCK_DISCLAIMER =
	'*Total Monthly Leasing Price includes base rent, all monthly mandatory and any user-selected optional fees. Excludes variable, usage-based, and required charges due at or prior to move-in or at move-out. Security Deposit may change based on screening results, but total will not exceed legal maximums. Some items may be taxed under applicable law. Some fees may not apply to rental homes subject to an affordable program. All fees are subject to application and/or lease terms. Prices and availability subject to change.'

export const MOCK_DISCLAIMER_LINK = {
	url: 'https://www.engrain.com/',
	title: 'Learn more',
	target: '_blank'
}

export const MOCK_GALLERY_IMAGES = [
	{
		src: FPO_IMAGE,
		caption: 'Spacious living room with natural light and modern finishes.'
	},
	{
		src: FPO_IMAGE,
		caption:
			'Updated kitchen with quartz countertops and stainless steel appliances.'
	},
	{
		src: FPO_IMAGE,
		caption: 'Primary bedroom with walk-in closet and ensuite bath.'
	},
	{ src: FPO_IMAGE, caption: 'Private balcony with mountain views.' },
	{ src: FPO_IMAGE }
]

export const MOCK_LEASE_OPTIONS = [
	{ term: '12 Months', baseRent: '$2,050', rentValue: 2050 },
	{ term: '14 Months', baseRent: '$1,950', rentValue: 1950 },
	{ term: '10 Months', baseRent: '$2,200', rentValue: 2200 },
	{ term: '6 Months', baseRent: '$2,450', rentValue: 2450 }
]

export const MOCK_VIEW_OPTIONS = [
	{ value: 'pet-park', label: 'Pet Park View', count: 8 },
	{ value: 'cabana', label: 'Cabana View', count: 16 },
	{ value: 'retail', label: 'Retail View', count: 6 },
	{ value: 'residential', label: 'Residential View', count: 2 },
	{ value: 'community', label: 'Community View', count: 5 },
	{ value: 'courtyard', label: 'Courtyard View', count: 8 },
	{ value: 'city', label: 'City View', count: 0 },
	{ value: 'mountain', label: 'Mountain View', count: 9 },
	{ value: 'parking-lot', label: 'Parking Lot View', count: 4 },
	{ value: 'pool', label: 'Pool View', count: 3 }
]

export const MOCK_FEATURE_OPTIONS = [
	{ value: 'washer-dryer', label: 'In-Home Washer & Dryer', count: 12 },
	{ value: 'stainless', label: 'Stainless Steel Appliances', count: 10 },
	{ value: 'quartz', label: 'Quartz-Style Countertops', count: 16 },
	{ value: 'balcony', label: 'Wrap-Around Balcony', count: 8 },
	{ value: 'ceiling-fan', label: 'Ceiling Fan', count: 12 },
	{ value: 'fireplace', label: 'Gas Fireplace', count: 0 },
	{ value: 'smart-thermostat', label: 'Smart Thermostat', count: 6 },
	{ value: 'hardwood-floors', label: 'Hardwood Floors', count: 14 },
	{ value: 'walk-in-closet', label: 'Walk-In Closet', count: 11 },
	{ value: 'granite-countertops', label: 'Granite Countertops', count: 9 },
	{ value: 'ev-charging', label: 'EV Charging Station', count: 3 },
	{ value: 'pet-friendly', label: 'Pet Friendly', count: 18 },
	{ value: 'rooftop-deck', label: 'Rooftop Deck', count: 5 },
	{ value: 'pool', label: 'Swimming Pool', count: 7 },
	{ value: 'fitness-center', label: 'Fitness Center', count: 15 },
	{ value: 'concierge', label: 'Concierge Service', count: 2 },
	{ value: 'package-lockers', label: 'Package Lockers', count: 13 },
	{ value: 'controlled-access', label: 'Controlled Access Entry', count: 10 },
	{ value: 'bike-storage', label: 'Bike Storage', count: 4 },
	{ value: 'dog-park', label: 'Dog Park', count: 6 },
	{ value: 'coworking-space', label: 'Co-Working Space', count: 8 }
]
